import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Box, CardMedia } from "@mui/material";

import RedirectButton from "./../../../ui-components/Buttons/RedirectButton";

import {     } from "../../../../store/slices/question";
import { useSelector } from "../../../../store";
import { quizData } from "../../../../constants";

export default function MobileInstructions() {
	const location = useLocation();
	const navigate = useNavigate();
	const learner = useSelector((state) => state.learner || {});
	const [isDisabled, setIsDisabled] = React.useState(true);
	const [btnCd, setBtnCd] = React.useState(25);
	const publicUrl = process.env.PUBLIC_URL;
	const videoSrc = quizData[learner?.details?.testLevel || 'acsf3shortcourse'].src;

	const videoRef = React.useRef();

	let timer = setTimeout(function () {
		if (btnCd - 1 === 0) {
			setIsDisabled(false);
		}
		setBtnCd(btnCd - 1);
	}, 1000);

	React.useEffect(() => {
		if (btnCd === 0 && typeof timer !== "undefined") {
			clearTimeout(timer);
		}
	}, [btnCd, timer]);
	const handleConfirmDeclaration = async () => {
		// await dispatch(getNextQuestion([]));

		navigate(`${publicUrl}/question${location?.search || ""}`);
	};
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
                <CardMedia
                    component="video" autoPlay
					controls
					controlsList="nodownload noplaybackrate"
					ref={videoRef}
                    sx={{
						width: "100%",
						marginBottom: "1rem",
						borderRadius: "1rem",
						boxShadow: "1px 1px 1px 2px #383535",
                        height: {md: '57vh', sm: 'auto'}
					}}
                    src={videoSrc}
                />
				{/* <video
					src="https://s3.ap-southeast-2.amazonaws.com/static.lln.training/acsf3-short-quiz-resources/videos/instructions.mp4"
					autoPlay={true}
					controls
					ref={videoRef}
					style={{
						width: "100%",
						marginBottom: "1rem",
						borderRadius: "1rem",
						boxShadow: "1px 1px 1px 2px #383535",
					}}
					controlsList="nodownload noplaybackrate"
					disablePictureInPicture
				/> */}

				<RedirectButton
					disabled={isDisabled}
					handleClick={handleConfirmDeclaration}
					title={`Start ` + (btnCd > 0 ? `${btnCd}s` : "")}
				/>
			</Box>
		</React.Fragment>
	);
}